import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "54",
  height: "34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "m53.075 22.713-4.515-1.32a9.43 9.43 0 0 0-16.844-2.32l-6.13-1.021a1 1 0 1 0-.328 1.972l5.505.918a9.343 9.343 0 0 0-.586 2.629 6.073 6.073 0 0 0-6.554.125 9.427 9.427 0 0 0-18.7-1.024H2.5L10.51 3.5a2.28 2.28 0 0 1 1.244-1.18 2.809 2.809 0 0 1 2.272.625 1 1 0 1 0 1.11-1.664A4.641 4.641 0 0 0 11.158.41a4.222 4.222 0 0 0-2.493 2.316L.077 23.286A1 1 0 0 0 1 24.673h3.8a9.428 9.428 0 0 0 18.48 2.227.99.99 0 0 0 .118-.153 4.157 4.157 0 0 1 7.01-.291A9.426 9.426 0 0 0 49 24.672h3.8a1 1 0 0 0 .282-1.96M14.214 31.72a7.438 7.438 0 1 1 7.44-7.438 7.446 7.446 0 0 1-7.44 7.438m25.365 0a7.438 7.438 0 1 1 7.438-7.438 7.446 7.446 0 0 1-7.438 7.438",
  fill: "#000"
}, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M14.165 18.041a6.348 6.348 0 0 0-6.341 6.341.85.85 0 0 0 1.7 0 4.65 4.65 0 0 1 4.644-4.644.85.85 0 0 0 0-1.7M39.529 18.041a6.347 6.347 0 0 0-6.341 6.341.85.85 0 1 0 1.7 0 4.65 4.65 0 0 1 4.644-4.644.85.85 0 0 0 0-1.7M20.19 4.973a12.133 12.133 0 0 1 8.61 6.958c.025.056.058.148.1.254l-1.488-.358a1 1 0 0 0-.469 1.944l3.614.871a.99.99 0 0 0 .746-.112 1 1 0 0 0 .367-.382l1.674-3.074a1 1 0 1 0-1.756-.957l-.78 1.432a7.377 7.377 0 0 0-.177-.433A14.156 14.156 0 0 0 20.5 2.992a1 1 0 0 0-.307 1.977",
  fill: "#000"
}, null, -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }